import gql from 'graphql-tag';

export default gql`
  mutation createManyEventMutation($records: [CreateManyEventInput!]!) {
    createManyEventMutation(records: $records) {
      records {
        _id
        title
        status
        color
        dateTime
        data {
          eventType
        }
      }
    }
  }
`;
